// source: no/jotta/openapi/people/v1/people.v1.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var no_jotta_openapi_ping_pb = require('../../../../../no/jotta/openapi/ping_pb.js');
goog.object.extend(proto, no_jotta_openapi_ping_pb);
var google_api_annotations_pb = require('../../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.Bounds', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetPeopleRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetPeopleResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetPersonRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetPersonResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.MergePeopleRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.MergePeopleResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.PatchPersonRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.PatchPersonResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.people.v1.Person', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.Person = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.Person, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.Person.displayName = 'proto.no.jotta.openapi.people.v1.Person';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.Bounds = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.Bounds, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.Bounds.displayName = 'proto.no.jotta.openapi.people.v1.Bounds';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetPersonRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetPersonRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetPersonRequest.displayName = 'proto.no.jotta.openapi.people.v1.GetPersonRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetPersonResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetPersonResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetPersonResponse.displayName = 'proto.no.jotta.openapi.people.v1.GetPersonResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.displayName = 'proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.displayName = 'proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.displayName = 'proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.displayName = 'proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.displayName = 'proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.displayName = 'proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.displayName = 'proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetPeopleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetPeopleRequest.displayName = 'proto.no.jotta.openapi.people.v1.GetPeopleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.people.v1.GetPeopleResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetPeopleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetPeopleResponse.displayName = 'proto.no.jotta.openapi.people.v1.GetPeopleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.displayName = 'proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.PatchPersonRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.PatchPersonRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.PatchPersonRequest.displayName = 'proto.no.jotta.openapi.people.v1.PatchPersonRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.PatchPersonResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.PatchPersonResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.PatchPersonResponse.displayName = 'proto.no.jotta.openapi.people.v1.PatchPersonResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest.displayName = 'proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.displayName = 'proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.displayName = 'proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.MergePeopleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.people.v1.MergePeopleRequest.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.MergePeopleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.MergePeopleRequest.displayName = 'proto.no.jotta.openapi.people.v1.MergePeopleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.people.v1.MergePeopleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.people.v1.MergePeopleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.people.v1.MergePeopleResponse.displayName = 'proto.no.jotta.openapi.people.v1.MergePeopleResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.Person.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.Person.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.Person} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.Person.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    thumbUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    thumbEncodedContentRef: jspb.Message.getFieldWithDefault(msg, 4, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.Person}
 */
proto.no.jotta.openapi.people.v1.Person.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.Person;
  return proto.no.jotta.openapi.people.v1.Person.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.Person} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.Person}
 */
proto.no.jotta.openapi.people.v1.Person.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbEncodedContentRef(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.Person.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.Person.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.Person} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.Person.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getThumbUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getThumbEncodedContentRef();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.Person.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.Person} returns this
 */
proto.no.jotta.openapi.people.v1.Person.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string thumb_url = 2;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.Person.prototype.getThumbUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.Person} returns this
 */
proto.no.jotta.openapi.people.v1.Person.prototype.setThumbUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string thumb_encoded_content_ref = 4;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.Person.prototype.getThumbEncodedContentRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.Person} returns this
 */
proto.no.jotta.openapi.people.v1.Person.prototype.setThumbEncodedContentRef = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.Person.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.Person} returns this
 */
proto.no.jotta.openapi.people.v1.Person.prototype.setName = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.Person} returns this
 */
proto.no.jotta.openapi.people.v1.Person.prototype.clearName = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.Person.prototype.hasName = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.Bounds.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.Bounds.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.Bounds} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.Bounds.toObject = function(includeInstance, msg) {
  var f, obj = {
    left: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    top: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    right: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    bottom: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.Bounds}
 */
proto.no.jotta.openapi.people.v1.Bounds.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.Bounds;
  return proto.no.jotta.openapi.people.v1.Bounds.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.Bounds} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.Bounds}
 */
proto.no.jotta.openapi.people.v1.Bounds.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLeft(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTop(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRight(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBottom(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.Bounds.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.Bounds.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.Bounds} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.Bounds.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLeft();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getTop();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getRight();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getBottom();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional double left = 1;
 * @return {number}
 */
proto.no.jotta.openapi.people.v1.Bounds.prototype.getLeft = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.people.v1.Bounds} returns this
 */
proto.no.jotta.openapi.people.v1.Bounds.prototype.setLeft = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double top = 2;
 * @return {number}
 */
proto.no.jotta.openapi.people.v1.Bounds.prototype.getTop = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.people.v1.Bounds} returns this
 */
proto.no.jotta.openapi.people.v1.Bounds.prototype.setTop = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double right = 3;
 * @return {number}
 */
proto.no.jotta.openapi.people.v1.Bounds.prototype.getRight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.people.v1.Bounds} returns this
 */
proto.no.jotta.openapi.people.v1.Bounds.prototype.setRight = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double bottom = 4;
 * @return {number}
 */
proto.no.jotta.openapi.people.v1.Bounds.prototype.getBottom = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.people.v1.Bounds} returns this
 */
proto.no.jotta.openapi.people.v1.Bounds.prototype.setBottom = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetPersonRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetPersonRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetPersonRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPersonRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetPersonRequest}
 */
proto.no.jotta.openapi.people.v1.GetPersonRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetPersonRequest;
  return proto.no.jotta.openapi.people.v1.GetPersonRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetPersonRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetPersonRequest}
 */
proto.no.jotta.openapi.people.v1.GetPersonRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetPersonRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetPersonRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetPersonRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPersonRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.GetPersonRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPersonRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetPersonRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetPersonResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetPersonResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetPersonResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPersonResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    person: (f = msg.getPerson()) && proto.no.jotta.openapi.people.v1.Person.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetPersonResponse}
 */
proto.no.jotta.openapi.people.v1.GetPersonResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetPersonResponse;
  return proto.no.jotta.openapi.people.v1.GetPersonResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetPersonResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetPersonResponse}
 */
proto.no.jotta.openapi.people.v1.GetPersonResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.people.v1.Person;
      reader.readMessage(value,proto.no.jotta.openapi.people.v1.Person.deserializeBinaryFromReader);
      msg.setPerson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetPersonResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetPersonResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetPersonResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPersonResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPerson();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.people.v1.Person.serializeBinaryToWriter
    );
  }
};


/**
 * optional Person person = 1;
 * @return {?proto.no.jotta.openapi.people.v1.Person}
 */
proto.no.jotta.openapi.people.v1.GetPersonResponse.prototype.getPerson = function() {
  return /** @type{?proto.no.jotta.openapi.people.v1.Person} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.people.v1.Person, 1));
};


/**
 * @param {?proto.no.jotta.openapi.people.v1.Person|undefined} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPersonResponse} returns this
*/
proto.no.jotta.openapi.people.v1.GetPersonResponse.prototype.setPerson = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetPersonResponse} returns this
 */
proto.no.jotta.openapi.people.v1.GetPersonResponse.prototype.clearPerson = function() {
  return this.setPerson(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetPersonResponse.prototype.hasPerson = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    personId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
    debug: jspb.Message.getBooleanFieldWithDefault(msg, 999, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest;
  return proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPersonId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 999:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDebug(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPersonId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 999));
  if (f != null) {
    writer.writeBool(
      999,
      f
    );
  }
};


/**
 * optional string person_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.getPersonId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.setPersonId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string cursor = 2;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.setCursor = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.clearCursor = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.hasCursor = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.clearPageSize = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.hasPageSize = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool debug = 999;
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.getDebug = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 999, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.setDebug = function(value) {
  return jspb.Message.setField(this, 999, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.clearDebug = function() {
  return jspb.Message.setField(this, 999, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonRequest.prototype.hasDebug = function() {
  return jspb.Message.getField(this, 999) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    cursor: jspb.Message.getFieldWithDefault(msg, 1, ""),
    photoList: jspb.Message.toObjectList(msg.getPhotoList(),
    proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse;
  return proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo;
      reader.readMessage(value,proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.deserializeBinaryFromReader);
      msg.addPhoto(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPhotoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.toObject = function(includeInstance, msg) {
  var f, obj = {
    md5: jspb.Message.getFieldWithDefault(msg, 1, ""),
    thumbUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    encodedContentRef: jspb.Message.getFieldWithDefault(msg, 3, ""),
    cursor: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo;
  return proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMd5(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedContentRef(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMd5();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getThumbUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEncodedContentRef();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string md5 = 1;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.prototype.getMd5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.prototype.setMd5 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string thumb_url = 2;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.prototype.getThumbUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.prototype.setThumbUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string encoded_content_ref = 3;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.prototype.getEncodedContentRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.prototype.setEncodedContentRef = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string cursor = 4;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.prototype.setCursor = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.prototype.clearCursor = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo.prototype.hasCursor = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string cursor = 1;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.prototype.setCursor = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.prototype.clearCursor = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.prototype.hasCursor = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Photo photo = 2;
 * @return {!Array<!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo>}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.prototype.getPhotoList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo, 2));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo>} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse} returns this
*/
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.prototype.setPhotoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo}
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.prototype.addPhoto = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.Photo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse} returns this
 */
proto.no.jotta.openapi.people.v1.GetPhotosWithPersonResponse.prototype.clearPhotoList = function() {
  return this.setPhotoList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    md5: jspb.Message.getFieldWithDefault(msg, 1, ""),
    debug: jspb.Message.getBooleanFieldWithDefault(msg, 999, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest;
  return proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMd5(value);
      break;
    case 999:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDebug(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMd5();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 999));
  if (f != null) {
    writer.writeBool(
      999,
      f
    );
  }
};


/**
 * optional string md5 = 1;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.prototype.getMd5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.prototype.setMd5 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool debug = 999;
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.prototype.getDebug = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 999, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.prototype.setDebug = function(value) {
  return jspb.Message.setField(this, 999, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.prototype.clearDebug = function() {
  return jspb.Message.setField(this, 999, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoRequest.prototype.hasDebug = function() {
  return jspb.Message.getField(this, 999) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    faceList: jspb.Message.toObjectList(msg.getFaceList(),
    proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse;
  return proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto;
      reader.readMessage(value,proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.deserializeBinaryFromReader);
      msg.addFace(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFaceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.toObject = function(includeInstance, msg) {
  var f, obj = {
    debug: (f = msg.getDebug()) && proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto;
  return proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 999:
      var value = new proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug;
      reader.readMessage(value,proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.deserializeBinaryFromReader);
      msg.setDebug(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDebug();
  if (f != null) {
    writer.writeMessage(
      999,
      f,
      proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.toObject = function(includeInstance, msg) {
  var f, obj = {
    bounds: (f = msg.getBounds()) && proto.no.jotta.openapi.people.v1.Bounds.toObject(includeInstance, f),
    faceThumbUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    person: (f = msg.getPerson()) && proto.no.jotta.openapi.people.v1.Person.toObject(includeInstance, f),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug;
  return proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.people.v1.Bounds;
      reader.readMessage(value,proto.no.jotta.openapi.people.v1.Bounds.deserializeBinaryFromReader);
      msg.setBounds(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFaceThumbUrl(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.people.v1.Person;
      reader.readMessage(value,proto.no.jotta.openapi.people.v1.Person.deserializeBinaryFromReader);
      msg.setPerson(value);
      break;
    case 4:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBounds();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.people.v1.Bounds.serializeBinaryToWriter
    );
  }
  f = message.getFaceThumbUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPerson();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.people.v1.Person.serializeBinaryToWriter
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional Bounds bounds = 1;
 * @return {?proto.no.jotta.openapi.people.v1.Bounds}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.prototype.getBounds = function() {
  return /** @type{?proto.no.jotta.openapi.people.v1.Bounds} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.people.v1.Bounds, 1));
};


/**
 * @param {?proto.no.jotta.openapi.people.v1.Bounds|undefined} value
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug} returns this
*/
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.prototype.setBounds = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug} returns this
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.prototype.clearBounds = function() {
  return this.setBounds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.prototype.hasBounds = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string face_thumb_url = 3;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.prototype.getFaceThumbUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug} returns this
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.prototype.setFaceThumbUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Person person = 2;
 * @return {?proto.no.jotta.openapi.people.v1.Person}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.prototype.getPerson = function() {
  return /** @type{?proto.no.jotta.openapi.people.v1.Person} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.people.v1.Person, 2));
};


/**
 * @param {?proto.no.jotta.openapi.people.v1.Person|undefined} value
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug} returns this
*/
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.prototype.setPerson = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug} returns this
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.prototype.clearPerson = function() {
  return this.setPerson(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.prototype.hasPerson = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * map<string, string> metadata = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug} returns this
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;
};


/**
 * optional Debug debug = 999;
 * @return {?proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.prototype.getDebug = function() {
  return /** @type{?proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug, 999));
};


/**
 * @param {?proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.Debug|undefined} value
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto} returns this
*/
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.prototype.setDebug = function(value) {
  return jspb.Message.setWrapperField(this, 999, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto} returns this
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.prototype.clearDebug = function() {
  return this.setDebug(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto.prototype.hasDebug = function() {
  return jspb.Message.getField(this, 999) != null;
};


/**
 * repeated FaceInPhoto face = 1;
 * @return {!Array<!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto>}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.prototype.getFaceList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto>} value
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse} returns this
*/
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.prototype.setFaceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto}
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.prototype.addFace = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.FaceInPhoto, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse} returns this
 */
proto.no.jotta.openapi.people.v1.GetFacesInPhotoResponse.prototype.clearFaceList = function() {
  return this.setFaceList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetPeopleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetPeopleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cursor: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    debug: jspb.Message.getBooleanFieldWithDefault(msg, 999, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleRequest}
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetPeopleRequest;
  return proto.no.jotta.openapi.people.v1.GetPeopleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetPeopleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleRequest}
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 999:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDebug(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetPeopleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetPeopleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 999));
  if (f != null) {
    writer.writeBool(
      999,
      f
    );
  }
};


/**
 * optional string cursor = 1;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.prototype.setCursor = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.prototype.clearCursor = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.prototype.hasCursor = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint32 page_size = 2;
 * @return {number}
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.prototype.clearPageSize = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.prototype.hasPageSize = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool debug = 999;
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.prototype.getDebug = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 999, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.prototype.setDebug = function(value) {
  return jspb.Message.setField(this, 999, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.prototype.clearDebug = function() {
  return jspb.Message.setField(this, 999, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetPeopleRequest.prototype.hasDebug = function() {
  return jspb.Message.getField(this, 999) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.repeatedFields_ = [1,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetPeopleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetPeopleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    personsDeprecatedList: jspb.Message.toObjectList(msg.getPersonsDeprecatedList(),
    proto.no.jotta.openapi.people.v1.Person.toObject, includeInstance),
    personsList: jspb.Message.toObjectList(msg.getPersonsList(),
    proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.toObject, includeInstance),
    cursor: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetPeopleResponse;
  return proto.no.jotta.openapi.people.v1.GetPeopleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetPeopleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.people.v1.Person;
      reader.readMessage(value,proto.no.jotta.openapi.people.v1.Person.deserializeBinaryFromReader);
      msg.addPersonsDeprecated(value);
      break;
    case 3:
      var value = new proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson;
      reader.readMessage(value,proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.deserializeBinaryFromReader);
      msg.addPersons(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetPeopleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetPeopleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPersonsDeprecatedList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.people.v1.Person.serializeBinaryToWriter
    );
  }
  f = message.getPersonsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.toObject = function(includeInstance, msg) {
  var f, obj = {
    person: (f = msg.getPerson()) && proto.no.jotta.openapi.people.v1.Person.toObject(includeInstance, f),
    cursor: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson;
  return proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.people.v1.Person;
      reader.readMessage(value,proto.no.jotta.openapi.people.v1.Person.deserializeBinaryFromReader);
      msg.setPerson(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPerson();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.people.v1.Person.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Person person = 1;
 * @return {?proto.no.jotta.openapi.people.v1.Person}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.prototype.getPerson = function() {
  return /** @type{?proto.no.jotta.openapi.people.v1.Person} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.people.v1.Person, 1));
};


/**
 * @param {?proto.no.jotta.openapi.people.v1.Person|undefined} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson} returns this
*/
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.prototype.setPerson = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson} returns this
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.prototype.clearPerson = function() {
  return this.setPerson(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.prototype.hasPerson = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string cursor = 2;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson} returns this
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.prototype.setCursor = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson} returns this
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.prototype.clearCursor = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson.prototype.hasCursor = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Person persons_deprecated = 1;
 * @return {!Array<!proto.no.jotta.openapi.people.v1.Person>}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.prototype.getPersonsDeprecatedList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.people.v1.Person>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.people.v1.Person, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.people.v1.Person>} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse} returns this
*/
proto.no.jotta.openapi.people.v1.GetPeopleResponse.prototype.setPersonsDeprecatedList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.people.v1.Person=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.people.v1.Person}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.prototype.addPersonsDeprecated = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.people.v1.Person, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse} returns this
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.prototype.clearPersonsDeprecatedList = function() {
  return this.setPersonsDeprecatedList([]);
};


/**
 * repeated PagedPerson persons = 3;
 * @return {!Array<!proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson>}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.prototype.getPersonsList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson, 3));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson>} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse} returns this
*/
proto.no.jotta.openapi.people.v1.GetPeopleResponse.prototype.setPersonsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.prototype.addPersons = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.no.jotta.openapi.people.v1.GetPeopleResponse.PagedPerson, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse} returns this
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.prototype.clearPersonsList = function() {
  return this.setPersonsList([]);
};


/**
 * optional string cursor = 2;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse} returns this
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.prototype.setCursor = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetPeopleResponse} returns this
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.prototype.clearCursor = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetPeopleResponse.prototype.hasCursor = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.PatchPersonRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.PatchPersonRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.PatchPersonRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.PatchPersonRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    personId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.PatchPersonRequest}
 */
proto.no.jotta.openapi.people.v1.PatchPersonRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.PatchPersonRequest;
  return proto.no.jotta.openapi.people.v1.PatchPersonRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.PatchPersonRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.PatchPersonRequest}
 */
proto.no.jotta.openapi.people.v1.PatchPersonRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPersonId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.PatchPersonRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.PatchPersonRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.PatchPersonRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.PatchPersonRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPersonId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string person_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.PatchPersonRequest.prototype.getPersonId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.PatchPersonRequest} returns this
 */
proto.no.jotta.openapi.people.v1.PatchPersonRequest.prototype.setPersonId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.PatchPersonRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.PatchPersonRequest} returns this
 */
proto.no.jotta.openapi.people.v1.PatchPersonRequest.prototype.setName = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.PatchPersonRequest} returns this
 */
proto.no.jotta.openapi.people.v1.PatchPersonRequest.prototype.clearName = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.PatchPersonRequest.prototype.hasName = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.PatchPersonResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.PatchPersonResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.PatchPersonResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.PatchPersonResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    person: (f = msg.getPerson()) && proto.no.jotta.openapi.people.v1.Person.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.PatchPersonResponse}
 */
proto.no.jotta.openapi.people.v1.PatchPersonResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.PatchPersonResponse;
  return proto.no.jotta.openapi.people.v1.PatchPersonResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.PatchPersonResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.PatchPersonResponse}
 */
proto.no.jotta.openapi.people.v1.PatchPersonResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.people.v1.Person;
      reader.readMessage(value,proto.no.jotta.openapi.people.v1.Person.deserializeBinaryFromReader);
      msg.setPerson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.PatchPersonResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.PatchPersonResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.PatchPersonResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.PatchPersonResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPerson();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.people.v1.Person.serializeBinaryToWriter
    );
  }
};


/**
 * optional Person person = 1;
 * @return {?proto.no.jotta.openapi.people.v1.Person}
 */
proto.no.jotta.openapi.people.v1.PatchPersonResponse.prototype.getPerson = function() {
  return /** @type{?proto.no.jotta.openapi.people.v1.Person} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.people.v1.Person, 1));
};


/**
 * @param {?proto.no.jotta.openapi.people.v1.Person|undefined} value
 * @return {!proto.no.jotta.openapi.people.v1.PatchPersonResponse} returns this
*/
proto.no.jotta.openapi.people.v1.PatchPersonResponse.prototype.setPerson = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.PatchPersonResponse} returns this
 */
proto.no.jotta.openapi.people.v1.PatchPersonResponse.prototype.clearPerson = function() {
  return this.setPerson(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.PatchPersonResponse.prototype.hasPerson = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    personId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest;
  return proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPersonId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPersonId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string person_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest.prototype.getPersonId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest} returns this
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesRequest.prototype.setPersonId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    mergeCandidateList: jspb.Message.toObjectList(msg.getMergeCandidateList(),
    proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse;
  return proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate;
      reader.readMessage(value,proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.deserializeBinaryFromReader);
      msg.addMergeCandidate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMergeCandidateList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.toObject = function(includeInstance, msg) {
  var f, obj = {
    person: (f = msg.getPerson()) && proto.no.jotta.openapi.people.v1.Person.toObject(includeInstance, f),
    similarityScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate;
  return proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.people.v1.Person;
      reader.readMessage(value,proto.no.jotta.openapi.people.v1.Person.deserializeBinaryFromReader);
      msg.setPerson(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSimilarityScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPerson();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.people.v1.Person.serializeBinaryToWriter
    );
  }
  f = message.getSimilarityScore();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional Person person = 1;
 * @return {?proto.no.jotta.openapi.people.v1.Person}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.prototype.getPerson = function() {
  return /** @type{?proto.no.jotta.openapi.people.v1.Person} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.people.v1.Person, 1));
};


/**
 * @param {?proto.no.jotta.openapi.people.v1.Person|undefined} value
 * @return {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate} returns this
*/
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.prototype.setPerson = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate} returns this
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.prototype.clearPerson = function() {
  return this.setPerson(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.prototype.hasPerson = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double similarity_score = 2;
 * @return {number}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.prototype.getSimilarityScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate} returns this
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate.prototype.setSimilarityScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * repeated MergeCandidate merge_candidate = 1;
 * @return {!Array<!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate>}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.prototype.getMergeCandidateList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate>} value
 * @return {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse} returns this
*/
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.prototype.setMergeCandidateList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate}
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.prototype.addMergeCandidate = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.MergeCandidate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse} returns this
 */
proto.no.jotta.openapi.people.v1.GetMergeCandidatesResponse.prototype.clearMergeCandidateList = function() {
  return this.setMergeCandidateList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.people.v1.MergePeopleRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.MergePeopleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.MergePeopleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.MergePeopleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.MergePeopleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetPersonId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    personIdList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.MergePeopleRequest}
 */
proto.no.jotta.openapi.people.v1.MergePeopleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.MergePeopleRequest;
  return proto.no.jotta.openapi.people.v1.MergePeopleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.MergePeopleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.MergePeopleRequest}
 */
proto.no.jotta.openapi.people.v1.MergePeopleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetPersonId(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addPersonId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.MergePeopleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.MergePeopleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.MergePeopleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.MergePeopleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetPersonId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPersonIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * optional string target_person_id = 2;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.MergePeopleRequest.prototype.getTargetPersonId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.MergePeopleRequest} returns this
 */
proto.no.jotta.openapi.people.v1.MergePeopleRequest.prototype.setTargetPersonId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string person_id = 1;
 * @return {!Array<string>}
 */
proto.no.jotta.openapi.people.v1.MergePeopleRequest.prototype.getPersonIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.no.jotta.openapi.people.v1.MergePeopleRequest} returns this
 */
proto.no.jotta.openapi.people.v1.MergePeopleRequest.prototype.setPersonIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.people.v1.MergePeopleRequest} returns this
 */
proto.no.jotta.openapi.people.v1.MergePeopleRequest.prototype.addPersonId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.people.v1.MergePeopleRequest} returns this
 */
proto.no.jotta.openapi.people.v1.MergePeopleRequest.prototype.clearPersonIdList = function() {
  return this.setPersonIdList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.people.v1.MergePeopleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.people.v1.MergePeopleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.people.v1.MergePeopleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.MergePeopleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    personId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.people.v1.MergePeopleResponse}
 */
proto.no.jotta.openapi.people.v1.MergePeopleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.people.v1.MergePeopleResponse;
  return proto.no.jotta.openapi.people.v1.MergePeopleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.people.v1.MergePeopleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.people.v1.MergePeopleResponse}
 */
proto.no.jotta.openapi.people.v1.MergePeopleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPersonId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.people.v1.MergePeopleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.people.v1.MergePeopleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.people.v1.MergePeopleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.people.v1.MergePeopleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPersonId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string person_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.people.v1.MergePeopleResponse.prototype.getPersonId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.people.v1.MergePeopleResponse} returns this
 */
proto.no.jotta.openapi.people.v1.MergePeopleResponse.prototype.setPersonId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.no.jotta.openapi.people.v1);
